<template>
  <highcharts :options="chartOptions"></highcharts>
</template>

<script>
import { Chart } from 'highcharts-vue';

export default {
  components: {
    highcharts: Chart,
  },
  data() {
    return {};
  },
  computed: {
    projects: {
      get: function() {
        // console.log('Wall Index', this.wallIndex);
        return this.$store.state.projects;
      },
      set: function(Project) {
        this.$store.dispatch('setProjects', Project);
      },
    },
    schema: {
      get: function() {
        return this.$store.state.schema;
      },
      set: function(newSchema) {
        this.$store.dispatch('setSchema', newSchema);
      },
    },
    projectNames() {
      let names = [];
      this.projects.forEach(project => {
        names.push(project.project_name);
      });
      return names;
    },
    retvSeries() {
      let result = [];
      //   this.projects.forEach(project => {
      result.push({
        name: this.schema.inputs.step1.project_name,
        data: [this.schema.inputs.retv6C.retv || 0],
        // });
      });
      return result;
    },
    chartOptions() {
      return {
        chart: {
          type: 'column',
          height: 300,
          width: 300,
        },
        credits: {
          enabled: false,
        },
        title: {
          text: 'Project cumulative RETV value',
        },
        // subtitle: {
        //   text: 'Click the columns to view versions. Source: <a href="http://statcounter.com" target="_blank">statcounter.com</a>',
        // },
        // accessibility: {
        //   announceNewData: {
        //     enabled: true,
        //   },
        // },
        xAxis: {
          // type: 'category',
          // categories: this.projectNames,
          categories: [''],
          title: {
            text: 'Project',
          },
        },
        yAxis: {
          title: {
            text: 'RETV (W/m2)',
          },
          // height: '100%',
        },
        legend: {
          enabled: true,
        },
        plotOptions: {
          column: {
            minPointLength: 4,
          },
          // series: {
          //   borderWidth: 0,
          //   dataLabels: {
          //     enabled: true,
          //     format: '{point.y:.1f}%',
          //   },
          // },
        },

        // tooltip: {
        //   headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
        //   pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y:.2f}%</b> of total<br/>',
        // },
        series: this.retvSeries,
      };
    },
  },
};
</script>

<style></style>
